import { createContext, useContext, useState } from 'react'
import type { FC, ReactNode } from 'react'
import type { CookiePreferences } from '~/features/cookies/preferences'

interface CookieContextValue {
  isBannerOpen: boolean;
  setBannerOpen: (bannerOpen: boolean) => void;
  cookiePreferences: CookiePreferences;
  setCookiePreferences: (preferences: CookiePreferences) => void;
}

const CookieContext = createContext<CookieContextValue | null>(null)

const useCookieContext = (): CookieContextValue | null => useContext(CookieContext)

interface CookieContextProviderProps {
  children: ReactNode;
}

const CookieContextProvider: FC<CookieContextProviderProps> = ({ children }) => {
  const [isBannerOpen, setBannerOpen] = useState<boolean>(false)
  const [cookiePreferences, setCookiePreferences] = useState<CookiePreferences>({})

  const updateBannerOpen = (bannerOpen: boolean): void => {
    setBannerOpen(bannerOpen)
  }

  const updateCookiePreferences = (preferences: CookiePreferences): void => {
    setCookiePreferences((state) => {
      const mergedPreferences = {
        ...state,
        ...preferences
      }

      return mergedPreferences
    })
  }

  // TODO: Does this need to be optmised as per the below lint rule?
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value: CookieContextValue = {
    isBannerOpen,
    setBannerOpen: updateBannerOpen,
    cookiePreferences,
    setCookiePreferences: updateCookiePreferences
  }

  return (
    <CookieContext.Provider value={value}>
      {children}
    </CookieContext.Provider>
  )
}

export { useCookieContext, CookieContextProvider }

export type { CookieContextValue, CookieContextProviderProps }
